import React from 'react'
import { Stack } from 'react-bootstrap'
import { Field, Form, FormSaveButton } from '@ztechapps/webui.form'
import { ConversationSelect } from '@ztechapps/chat.webui'
import { useCreateOrderFromConversation } from '@ztechapps/order.webui'

// `{ field: null }` matches a stored null and a missing field alike.
const unlinkedConversationFilter = {
  'metadata.orderId': null,
  'metadata.purchaseOrderId': null,
  'metadata.logisticId': null,
}

export const AddNewFromConversationForm = ({ onSuccessSubmit }: { onSuccessSubmit?: (value: string) => void }) => {
  const { createOrderAndOpen } = useCreateOrderFromConversation({ onSuccessSubmit })

  const initialValues = {
    conversation: null,
  }

  const validate = (values) => {
    const errors: any = {}
    if (!values.conversation?._id) {
      errors.conversation = 'Required'
    }

    return errors
  }

  const onSubmit = async ({ conversation }) => {
    await createOrderAndOpen(conversation)
  }

  return (
    <Form onSubmit={onSubmit} initialValues={initialValues} validate={validate}>
      <Stack gap={2}>
        <Field
          name="conversation"
          component={ConversationSelect}
          label="Conversation"
          help="Select the conversation to create this order from."
          filter={unlinkedConversationFilter}
          onChange
        />
      </Stack>
      <div className={'d-flex justify-content-end mt-3'}>
        <FormSaveButton text="Create" />
      </div>
    </Form>
  )
}
